/* eslint-disable */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactModal from 'react-modal';
import Alert from 'react-s-alert';
import * as campanhaActions from './actions/campanhaActions'
import RatingPerguntaForm from './RatingPerguntaForm'
import Helpers from './util/Helpers'
import IniciaRating from './InciaRating'
import './css/rating/style.css'
import './css/modal.css'
import Erro from './Erro';
import SucessoPesquisa from './SucessoPesquisa';


//CSS para radio
//https://gist.github.com/rcotrina94/7828886
class RatingForm extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            imagemSelecionada:'',
            textoImgSelecionada:'',
            imagemClicada:!$.isEmptyObject(this.props.params) && this.props.params.voto ? this.props.params.voto : '',
            showModal: false,
            txtMensagem:'',
            reiniciarPagina:false,
            token: !$.isEmptyObject(this.props.params) && this.props.params.token ? this.props.params.token : null,
            voto: !$.isEmptyObject(this.props.params) && this.props.params.voto ? this.props.params.voto : null,
            erro:null,
            msgSucesso:null,
            tipoCampanha: !$.isEmptyObject(this.props.params) && this.props.params.tipo ? this.props.params.tipo : '1',
            idCampanha: !$.isEmptyObject(this.props.params) && this.props.params.idCampanha ? this.props.params.idCampanha : null,
            perguntaCampanha:null,
            campanhaAtiva:null,
            carregar:false
        }
        this.clickImg = this.clickImg.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.reiniciarPagina = this.reiniciarPagina.bind(this);
        this.onChangeTxtMensagem = this.onChangeTxtMensagem.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.validaForm = this.validaForm.bind(this);
        this.gerenciarCampanha = this.gerenciarCampanha.bind(this);
        this.recarregar = this.recarregar.bind(this);
      }
      
      validaForm() {
       
        var valido = true;
       
        var mensagem = this.refs.txtMensagem.value;
        
        if (this.state.imagemClicada === '') {
            $(this.refs.errMensagem).show();
            valido = false;
        }

        return valido;
    }

      
    cadastrar(event){
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        if (this.validaForm()) {
            var campanha = {}

                campanha = Object.assign({}, this.state.campanhaAtiva);
               
                var idEstrutura = this.props.params.idEstrutura?this.props.params.idEstrutura:0
               
                if(campanha.dado!=null && campanha.dado.mPerguntas!==null && campanha.dado.mRespostas!==null){
                    for (let index = 0; index < campanha.dado.mRespostas.length; index++) {
                        const resposta = campanha.dado.mRespostas[index];
                        if(this.state.token===null){
                            resposta.mIdCampanhaResposta = 0
                        }    
                        resposta.mObservacao = this.state.txtMensagem;
                        resposta.mEstruturaOrganizacional = {mIdEstruturaOrganizacional:idEstrutura}
                    }
                }
                var data = {campanha: campanha.dado};
            
                this.props.actions.gravar(data).then( this.handleOpenModal()).catch(error => {
                   
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });
                });;
                }
    }

    handleOpenModal () {
        
        if(this.state.token===null){
            this.setState({ showModal: true });
            var self = this;
            setTimeout(function(){self.handleCloseModal()}, 3000);
        }
        else{
            this.setState({msgSucesso: 'Obrigado pela participação'});
        }
    }
    
    handleCloseModal () {
        
        if(this.state.showModal === true){
            this.setState({ showModal: false });
            this.reiniciarPagina();
            this.gerenciarCampanha();
            
        }
        
    }

    onChangeTxtMensagem(e){
        this.setState({txtMensagem:e.target.value});
    }
    
    reiniciarPagina () {
        this.setState({ 
            imagemSelecionada:'', 
            imagemClicada:'',
            textoImgSelecionada:'',
            txtMensagem:'',
            reiniciarPagina:true
        });
       
    }

    clickImg(val, perguntaRespondida){
        
        $(this.refs.errMensagem).hide();
        this.setState({reiniciarPagina:false})
        this.setState({imagemSelecionada:val, imagemClicada:val, textoImgSelecionada:this.state.tipoCampanha==='1'?'Nota: '+val:Helpers.obteTextoEmoji(val)});
        
        var campanha = Object.assign({}, this.state.campanhaAtiva);
        
        if(campanha.dado!=null && campanha.dado.mPerguntas!==null && campanha.dado.mRespostas!==null){
            for (let index = 0; index < campanha.dado.mRespostas.length; index++) {
                const resposta = campanha.dado.mRespostas[index];
                if(resposta.mPergunta.mIdCampanhaPergunta == perguntaRespondida.mIdCampanhaPergunta){
                    resposta.mNota = val;
                    resposta.mObservacao = this.state.txtMensagem;
                    break;
                }
            }
            this.setState({campanhaAtiva:campanha});
        }
        //console.log('campanha com pergunta respondida ', val, campanha )
    }

    gerenciarCampanha(){
       
        if(this.state.token!==null){
            //console.log('token', this.state.token)
            var token= {
                token : this.state.token
            }

            this.props.actions.obterCampanhaPorToken(token).catch(error => {
               
                this.setState({erro: !$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText})
            });;
        }else{
            //console.log('idcampanha', this.state.idCampanha)
            var idCampanha= {
                idCampanha : this.state.idCampanha
            }
            Helpers.apresentarSpinner('Carregando campanha...');
            this.props.actions.obterCampanhaPorIdCampanha(idCampanha).then(()=>
            Helpers.removerSpinner(), this.recarregar())
            .catch(error => {
               
                this.setState({erro: !$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText})
            });;
        }

    }
    recarregar(){
        $(window).scrollTo($(this), 200, {
            offset: { left: 100, top: -200 },
            queue: false
          });
    }
    componentDidMount() {
        $('#header').hide();
        $('#includeChat').hide();
        this.gerenciarCampanha();
 
    }
    componentWillReceiveProps(nextProps){
        if (!$.isEmptyObject(nextProps.campanha) && this.props.campanha !== nextProps.campanha) {
           //console.log('passou nextProps', nextProps.campanha);
           var campanha = JSON.parse(JSON.stringify(nextProps.campanha));
           
            if(this.state.voto!==null && campanha.dado!=null && campanha.dado.mPerguntas!==null && campanha.dado.mRespostas!==null){
                var voto = parseInt(this.state.voto);
                if(voto>=0 && voto<=10){
                    const resposta = campanha.dado.mRespostas[0];
                    resposta.mNota = this.state.voto;
                }
            }

           //var campanha = Object.assign({}, nextProps.campanha);
           this.setState({campanhaAtiva:campanha, carregar:true});
        }
    }

    render() {
        if (!$.isEmptyObject(this.state.erro)){
            return <Erro mensagemErro={this.state.erro} />
        }
        if (!$.isEmptyObject(this.state.msgSucesso)){
            return <SucessoPesquisa msg={this.state.msgSucesso} />
        }
        if ($.isEmptyObject(this.props.campanha)){
            return <div/>
        }
        return (
            
            <div className="upform">


<form>

  <div className="upform-header"></div>
    <div className="upform-main">
        {this.props.campanha.dado.mPerguntas.map((pergunta, index) =>
                <RatingPerguntaForm pergunta={pergunta} key={index} idPosicao={index}  clickImg={this.clickImg} reiniciarPagina={this.state.reiniciarPagina} voto={this.state.voto}/>
            )}
    
        <div className="input-block">
            <div className="label labelPesquisa ">Gostaria de detalhar melhor sobre as notas dadas?</div>
            <div className="input-control">
                    <textarea rows="3" cols='50' name="txtMensagem" id='txtMensagem' placeholder="" ref='txtMensagem' id='txtMensagem' name='txtMensagem' onChange={this.onChangeTxtMensagem} value={this.state.txtMensagem} />
            </div>
        </div>
        <div className="upform-footer">
        <button type="submit" className='btn btn-special btn-color btn-small' onClick={this.cadastrar}>Enviar</button>
        </div>
    </div>

</form>
<IniciaRating carregar={this.state.carregar}/>
    <ReactModal 
        isOpen={this.state.showModal}
        contentLabel="onRequestClose Example" 
        onRequestClose={this.handleCloseModal}
        className="Modal"
        overlayClassName="Overlay"
    >
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div className='row central'><br/>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h2><strong> Obrigado pela participação!</strong></h2>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button onClick={this.handleCloseModal}>Fechar</button>
            </div>
        </div>
        </div>
    </ReactModal>
</div>

        );
    }
}
RatingForm.contextTypes = {
    router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
        campanha: state.campanha
    };
}

function mapDispatchToProps(dispatch){
   return {
        
       actions: bindActionCreators(campanhaActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(RatingForm);





/** WEBPACK FOOTER **
 ** ./src/components/RatingFormTF.js
 **/